import React from "react";
import styles from "./FormControl.module.css"

export const renderTextarea = ({
                                input,
                                placeholder,
                                type,
                                meta: { touched, error, warning }
                            }) => (
        <div className ={(touched && (error || warning))? styles.error : " "}>
            <textarea {...input} placeholder={placeholder} type={type} />
            {touched &&
            ((error && <span>{error}</span>) ||
                (warning && <span>{warning}</span>))}
        </div>
)
export const renderInput = ({
                                input,
                                placeholder,
                                type,
                                meta: { touched, error, warning }
                            }) => (
        <div className ={(touched && (error || warning))? styles.error : " "}>
            <input {...input} placeholder={placeholder} type={type} />
            {touched &&
            ((error && <span>{error}</span>) ||
                (warning && <span>{warning}</span>))}
        </div>
)
